module.exports = __webpack_public_path__ + "img/makiimsethintergrund.70bfdb12.jpg";